module.exports = __webpack_public_path__ + "fonts/RenaultLifeOldStyle-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/old-style/RenaultLifeOldStyle-Bold.eot
// module id = 339
// module chunks = 0